import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const Icon = ({
  size = 24,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-seed-icon": "true",
    "data-seed-icon-version": "0.0.10",
    width: size,
    height: size,
    ref,
    ...props,
    children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.27589 2.76052C7.89499 3.16043 7.9104 3.79341 8.31032 4.17431L16.55 12.0222L8.31037 19.8689C7.91042 20.2498 7.89496 20.8827 8.27584 21.2827C8.65671 21.6826 9.28969 21.6981 9.68963 21.3172L18.6896 12.7464C18.8878 12.5576 19 12.2959 19 12.0222C19 11.7486 18.8879 11.4868 18.6897 11.2981L9.68968 2.72608C9.28976 2.34518 8.65679 2.3606 8.27589 2.76052Z",
        fill: "currentColor"
      }
    ) })
  }
);
const IconChevronRightLine = forwardRef(Icon);
export default IconChevronRightLine;
